import { ProviderConfig, ProviderTypes } from 'types';
import { DefaultTheme } from 'config/themes';

export const NexGen: ProviderConfig = {
  providerType: ProviderTypes.LEC,
  providerCode: 'nexgen',
  dcCode: 'nexgen',
  name: 'NexGen',
  displayName: 'NexGen',
  reskinTheme: DefaultTheme,
  reskinTitle: 'NexGen Internet',
  showPricingDisclaimer: false,
  broadbandDisplayType: 'linkout_url',
};
